import { AdminLayoutComponent, AuthLayoutComponent } from "./core";

import { Routes } from "@angular/router";

export const AppRoutes: Routes =
  [
    // {
    //   path: '',
    //   redirectTo: 'session/packing',
    //   pathMatch: 'full',
    // },
    {
      path: '',
      redirectTo: 'session/forgot',
      pathMatch: 'full',
    },
    {
      path: '',
      component: AdminLayoutComponent,
      children: [{
        path: 'home',
        loadChildren: () => import("./dashboard/dashboard.module").then(m => m.DashboardModule)
      }
        , {
        path: 'pdm',
        loadChildren: () => import("./masters/masters.module").then(m => m.MastersModule)
      },
      {
        path: "ledger",
        loadChildren: () => import("./ledger/ledger.module").then(m => m.LedgerModule)
      },
      {
        path: "ordd",
        loadChildren: () => import("./dealerorder/dealerorder.module").then(m => m.DealerorderModule)
      }]
    }, {
      path: '',
      component: AuthLayoutComponent,
      children: [{
        path: "session",
        loadChildren: () => import("./session/session.module").then(m => m.SessionModule)
      }]
    }, {
      path: '**',
      redirectTo: 'session/404'
    }];